export const CALENDLY_URL = "https://calendly.com/ikhlefyahiaoui-imene/30min";
